
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/click-to-whatsapp-ads",
      function () {
        return require("private-next-pages/click-to-whatsapp-ads.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/click-to-whatsapp-ads"])
      });
    }
  